const digested: Record<string, string> = {};

export async function digestMessage(message: string): Promise<string> {
    if (!digested[message]) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        digested[message] = hashArray
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }
    return digested[message];
}
